module.exports = __webpack_public_path__ + "static/img/icon_large_list_s.c4eb345c.svg";